import { ProductInspectionDTO } from "./product-inspection.dto";
import { ProductInspection } from '../product-inspection.entity';
import { EntityRepository } from "typeorm";
import { ProductInspectionSampleDto } from "libs/shared-models/production-management/src/lib/product-inspection/product-inspection-samples.dto";
import { ProductInspectionSamples } from "../product-inspection-samples.entity";
import { ProductInspectionSamplesDTO } from "./product-inspection-samples.dto";

export class ProductInspecAdapter{

    public convertDtoToEntity(dto: ProductInspectionDTO): ProductInspection{
        console.log("testa",dto)
        try{
        const entity = new ProductInspection;
        entity.saleOrderId = dto.saleOrderId;
        entity.saleOrderItemId = dto.saleOrderItemId;
        entity.lotNumber = dto.lotNumber
        entity.section = dto.section
        entity.date = dto.date
        entity.isActive = dto.isActive == undefined ? true: dto.isActive;
        if(dto.inspectionId){
            entity.inspectionId = dto.inspectionId;
            entity.updatedAt = dto.updatedAt;
            entity.updatedUser = dto.updatedUser;
        }else{
            entity.isActive = true;
            entity.createdAt = dto.createdAt;
            entity.createdUser = dto.createdUser;
        }
        const sampleEntity : ProductInspectionSamples[] = [];
        for (const sample of dto.samplesInfo){
            const sampleentity = new ProductInspectionSamples()
            sampleentity.sampleNo = sample.sampleNo;
            sampleentity.temperature = sample.temperature;
            sampleentity.fillingWeight = sample.fillingWeight;
            sampleentity.frozenWeight = sample.frozenWeight;
            sampleentity.deglazedWeight = sample.deglazedWeight;
            sampleentity.netWeight = sample.netWeight;
            sampleentity.subSampleWeight = sample.subSampleWeight;
            sampleentity.frozenCount = sample.frozenCount;
            sampleentity.deglazedCount = sample.deglazedCount;
            sampleentity.netCount = sample.netCount;
            sampleentity.totalPieces = sample.totalPieces;
            sampleentity.glazePercent = sample.glazePercent;
            sampleentity.totalOunce = sample.totalOunce;
            sampleentity.cluster = sample.cluster;
            sampleentity.generalAppearance = sample.generalAppearance;
            sampleentity.generalOdour = sample.generalOdour;
            sampleentity.freshness = sample.freshness;
            sampleentity.texture = sample.texture;
            sampleentity.dehydration = sample.dehydration;
            sampleentity.discoloration = sample.discoloration;
            sampleentity.deterioration = sample.deterioration;
            sampleentity.peeling = sample.peeling;
            sampleentity.hangingMeat = sample.hangingMeat;
            sampleentity.blackSpot = sample.blackSpot;
            sampleentity.broken = sample.broken;
            sampleentity.wrongCut = sample.wrongCut;
            sampleentity.shells = sample.shells;
            sampleentity.foreignMatter = sample.foreignMatter;
            sampleentity.uniformityBig = sample.uniformityBig;
            sampleentity.uniformitySmall = sample.uniformitySmall;
            sampleentity.uniformityRatio = sample.uniformityRatio;
            sampleentity.productMetSpec = sample.productMetSpec;
            sampleentity.bestBefore = sample.bestBefore;
            sampleentity.remarks = sample.remarks;
            if(sample?.inspectionSampleId){
                sampleentity.inspectionSampleId = sample.inspectionSampleId;
                sampleentity.updatedUser = sample.updatedUser
            }else{
                sampleentity.createdUser=dto.createdUser
            }
            sampleEntity.push(sampleentity)
        }
        entity.samplesInfo=sampleEntity
        console.log("test"+dto)
         return entity;
    }
    catch(error){
        console.log("testb",error)
        return error
        
    }

    }

    public convertEntityToDto(entity: ProductInspection): ProductInspectionDTO{
        const dto = new ProductInspectionDTO;
        dto.saleOrderId = entity.saleOrderId;
        dto.saleOrderItemId  = entity.saleOrderItemId;
        dto.lotNumber = entity.lotNumber;
        dto.section = entity.section;
        dto.inspectionId = entity.inspectionId;
        dto.isActive = entity.isActive;
        dto.updatedAt = entity.updatedAt;
        dto.updatedUser = entity.updatedUser;
        dto.createdAt = entity.createdAt;
        dto.updatedUser = entity.createdUser;
        dto.versionFlag = entity.versionFlag;
        return dto;
    }

    public convertEntityToLabelDto(obj: ProductInspection): ProductInspectionDTO {
        const dto = new ProductInspectionDTO;
        dto.saleOrderId = obj.saleOrderId;
        dto.saleOrderItemId  = obj.saleOrderItemId;
        dto.lotNumber = obj.lotNumber;
        dto.section = obj.section;
        dto.inspectionId = obj.inspectionId;
        dto.isActive = obj.isActive;
        dto.updatedAt = obj.updatedAt;
        dto.updatedUser = obj.updatedUser;
        dto.createdAt = obj.createdAt;
        dto.updatedUser = obj.createdUser;
        dto.versionFlag = obj.versionFlag;
        const samplesInfo: ProductInspectionSamplesDTO[] = [];
        for (const sample of obj.samplesInfo) {
            const sampleentity = new ProductInspectionSamplesDTO();
            sampleentity.inspectionId = sample.inspectionId;
            sampleentity.inspectionSampleId = sample.inspectionSampleId;
            sampleentity.sampleNo = sample.sampleNo;
            sampleentity.temperature = sample.temperature;
            sampleentity.fillingWeight = sample.fillingWeight;
            sampleentity.frozenWeight = sample.frozenWeight;
            sampleentity.deglazedWeight = sample.deglazedWeight;
            sampleentity.netWeight = sample.netWeight;
            sampleentity.subSampleWeight = sample.subSampleWeight;
            sampleentity.frozenCount = sample.frozenCount;
            sampleentity.deglazedCount = sample.deglazedCount;
            sampleentity.netCount = sample.netCount;
            sampleentity.totalPieces = sample.totalPieces;
            sampleentity.glazePercent = sample.glazePercent;
            sampleentity.totalOunce = sample.totalOunce;
            sampleentity.cluster = sample.cluster;
            sampleentity.generalAppearance = sample.generalAppearance;
            sampleentity.generalOdour = sample.generalOdour;
            sampleentity.freshness = sample.freshness;
            sampleentity.texture = sample.texture;
            sampleentity.dehydration = sample.dehydration;
            sampleentity.discoloration = sample.discoloration;
            sampleentity.deterioration = sample.deterioration;
            sampleentity.peeling = sample.peeling;
            sampleentity.hangingMeat = sample.hangingMeat;
            sampleentity.blackSpot = sample.blackSpot;
            sampleentity.broken = sample.broken;
            sampleentity.wrongCut = sample.wrongCut;
            sampleentity.shells = sample.shells;
            sampleentity.foreignMatter = sample.foreignMatter;
            sampleentity.uniformityBig = sample.uniformityBig;
            sampleentity.uniformitySmall = sample.uniformitySmall;
            sampleentity.uniformityRatio = sample.uniformityRatio;
            sampleentity.productMetSpec = sample.productMetSpec;
            sampleentity.bestBefore = sample.bestBefore;
            sampleentity.remarks = sample.remarks;
            samplesInfo.push(sampleentity);
        }
        dto.samplesInfo = samplesInfo;
        return dto;
    }

}